import "./Home.css";
import React, { useState } from "react";
import PanellhniaPrwtathlhmataCarousel from "./PanellhniaPrwtathlhmataCarousel";
import Carousel from "react-bootstrap/Carousel";
import SiteHeader from "./../../components/SiteHeader";
import Age from "./../../components/Age";

const Home = () => {
  const korkutPos = { top: "35%", left: "66.5%" };
  const kaipiPos = { top: "48%", left: "28%" };

  const styles = {
    heroWrap: { position: "relative" },
    heroImg: { width: "100%", display: "block" },

    hsLayer: { position: "absolute", inset: 0, pointerEvents: "none" },
    hsItem: (top, left) => ({
      position: "absolute",
      top,
      left,
      transform: "translate(-50%, -50%)",
      pointerEvents: "auto",
      zIndex: 5,
    }),
    KaipiPin: {
      position: "relative",
      width: 22,
      height: 22,
      borderRadius: "50%",
      background: "blue",
      border: "2px solid #fff",
      boxShadow: "0 4px 10px rgba(0,0,0,.5)",
      cursor: "pointer",
    },
    KaipiPinTail: {
      content: '""',
      position: "absolute",
      left: "50%",
      bottom: -9,
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent",
      borderTop: "10px solid blue",
      filter: "drop-shadow(0 2px 4px rgba(0,0,0,.4))",
    },
    KubraPin: {
      position: "relative",
      width: 22,
      height: 22,
      borderRadius: "50%",
      background: "crimson",
      border: "2px solid #fff",
      boxShadow: "0 4px 10px rgba(0,0,0,.5)",
      cursor: "pointer",
    },
    KubraPinTail: {
      content: '""',
      position: "absolute",
      left: "50%",
      bottom: -9,
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent",
      borderTop: "10px solid crimson",
      filter: "drop-shadow(0 2px 4px rgba(0,0,0,.4))",
    },
    tip: (visible) => ({
      position: "absolute",
      bottom: "100%",
      left: "50%",
      transform: "translate(-50%, -8px)",
      display: visible ? "block" : "none",
      background: "rgba(0,0,0,.78)",
      color: "#fff",
      padding: "6px 10px",
      borderRadius: 8,
      fontSize: ".9rem",
      whiteSpace: "nowrap",
      backdropFilter: "blur(2px)",
      boxShadow: "0 6px 18px rgba(0,0,0,.35)",
    }),
    tipArrow: {
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderLeft: "8px solid transparent",
      borderRight: "8px solid transparent",
      borderTop: "8px solid rgba(0,0,0,.78)",
    },

    card: {
      background: "transparent",
      borderRadius: 20,
      overflow: "hidden",
      boxShadow: "0 14px 36px rgba(0,0,0,.35)",
    },
    imgTall: { height: "400px" , width: "auto", objectFit: "fit" },
    caption: {
      left: 0,
      right: 0,
      bottom: 0,
      textAlign: "left",
      background:
        "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.55) 60%, rgba(0,0,0,.85) 100%)",
      padding: "24px 20px",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
    capTitle: { margin: 0, fontWeight: 700, fontSize: "1.15rem" },
    capText: { margin: "6px 0 0 0", fontSize: ".95rem" },
  };

  const [showTip, setShowTip] = useState(false);
  const [showTip1, setShowTip1] = useState(false);

  const gotoIPTTFProfile = () =>
    (window.location.href = "http://stats.ipttc.org/en/profiles/6593");

  return (
    <>
      <div class="bodyContainer">
        <SiteHeader current="home" />

        <div class="homeContainer" style={styles.heroWrap}>
          <img
            src="/images/SingaporeSmash.jpg"
            alt="Singapore Smash"
            style={styles.heroImg}
          />
          <div style={styles.hsLayer}>
            <div
              style={styles.hsItem(kaipiPos.top, kaipiPos.left)}
              onMouseEnter={() => setShowTip(true)}
              onMouseLeave={() => setShowTip(false)}
              role="button"
              title="Kaipi Maria"
              onClick={() =>
                window.open("http://stats.ipttc.org/en/profiles/6593", "_blank")
              }
              aria-label="Kaipi Maria hotspot"
            >
              <div style={styles.tip(showTip)}>
                Kaipi Maria (Class 7)
                <div style={styles.tipArrow} />
              </div>
              <div style={styles.KaipiPin}>
                <div style={styles.KaipiPinTail} />
              </div>
            </div>
          </div>

          <div style={styles.hsLayer}>
            <div
              style={styles.hsItem(korkutPos.top, korkutPos.left)}
              onMouseEnter={() => setShowTip1(true)}
              onMouseLeave={() => setShowTip1(false)}
              role="button"
              title="Kübra Korkut"
              onClick={() =>
                window.open("http://stats.ipttc.org/en/profiles/3019", "_blank")
              }
              aria-label="Kübra Korkut hotspot"
            >
              <div style={styles.tip(showTip1)}>
                Kübra Korkut — World #2 (Class 7)
                <div style={styles.tipArrow} />
              </div>
              <div style={styles.KubraPin}>
                <div style={styles.KubraPinTail} />
              </div>
            </div>
          </div>

          <div class="row logoContainer p-4">
            <h1 class="logoName p-2">Καΐπη Μαρία</h1>
            <h3>
              Πρωταθλήτρια Ελλάδος στην Παρα - Eπιτραπέζια Aντισφαίριση από το 2021 - σήμερα
            </h3>
          </div>
        </div>

        <div class="page">
          <div class=" profileRow ">
            <div class="profileSection">
              <img
                className="profile-photo"
                src="/images/SingaporeSmashProfile.png"
                alt="Kaipi Maria Ismini at Singapore Smash"
              />

              <div className="infoCard">
                <div className="row" onClick={gotoIPTTFProfile} role="button">
                  <div className="col-lg-2 col-md-3 col-sm-4 col-xs-4">
                    <a
                      href="http://stats.ipttc.org/en/profiles/6593"
                      title="Back to ITTF PTT home page"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="ptt-logo">
                        <img
                          src="http://www.ipttc.org/logos/colour/PTT-110px.png"
                          alt="IPTTF Logo"
                        />
                      </div>
                    </a>
                  </div>
                  <div className="col align-self-center text-start">
                    <h1 className="mb-0">KAIPI Maria Ismini</h1>
                  </div>
                </div>

                <hr />
                <div className="text-start pt-2">
                  <h3>Woman, class 7 (Confirmed), <Age/> years old</h3>
                  <h3>Best rank #14 in class 7 — May 2023</h3>
                  <p
                    // href="/IporeiaMou/tournaments/GreekParaOpen2022"
                    className="h4 d-block mt-2"
                  >
                    Last tournament: 2023 ITTF Greek Para Open
                  </p>
                  <p
                    // href="/IporeiaMou/tournaments/MontenegrinParaChampionships2022"
                    className="h4 d-block"
                  >
                    First tournament: 2022 Montenegrin Para Championships
                  </p>
                  <h3 className="mt-3">
                    Minor medals (1) — 2023 ITTF Greek Para Open • Bronze in Mixed doubles class 14
                  </h3>
                </div>
              </div>
            </div>
            </div>
          </div>

          <div class="container ">
            <div class="row mt-5 mb-5 justify-content-center">
              <h1 class="text-center" style={{ marginTop: 100, marginBottom: 40 }}>
                <strong>ΠΡΟΣΦΑΤΕΣ ΕΠΙΤΥΧΙΕΣ (2026)</strong>
              </h1>
              {/* <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div class="text-left"   style={{width: "100%"}}>
                  <a href="#" class="title">
                  <h3 id="montenegro2026"><strong>Podgoritcha Open 2026</strong></h3>
                  <h4>Συμμετοχή στο Podgoritcha Open 2026</h4>
                  <h5>29 Απριλίου - 2 Μαΐου 2026</h5>
                </a></div>
                <div  style={{width: "100%", borderRadius: 20 }} >
                  <div style={styles.card}>
                      <Carousel >
                        <Carousel.Item>
                          <img
                            src="/images/2026/Podgorica_Open_2026.jpg"
                            alt="Podgorica Open 2026"
                            style={styles.imgTall}
                          />
                          <Carousel.Caption style={styles.caption}>
                            <h5 style={styles.capTitle}>Podgorica Open 2026 • Μαυροβούνιο</h5>
                          </Carousel.Caption>
                        </Carousel.Item>
                        </Carousel>
                  </div>
                </div>
              </div>
            
                <hr /> */}

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                
                <div class=""  style={{width: "100%", borderRadius: 20 }}>
                  <div style={styles.card}>
                    <Carousel interval={4000}>
                      <Carousel.Item>
                        <img
                          src="/images/2026/Panellhnio_1.jpg"
                          alt="Πανελλήνιο 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Χρυσό Μετάλλιο • Σ.Ε.Φ</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2026/Panellhnio_2.jpg"
                          alt="Πανελλήνιο 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Aπονομή</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2026/Panellhnio_3.jpg"
                          alt="Πανελλήνιο 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
                <div  style={{width: "100%"}} >
                  <a href="#" class="title">
                    <h3><strong>ΠΑΝΕΛΛΗΝΙΟ ΠΡΩΤΑΘΛΗΜΑ ΕΠΙΤΡΑΠΕΖΙΑΣ ΑΝΤΙΣΦΑΙΡΙΣΗΣ ΑΜΕΑ 2026</strong></h3>
                    <h4>Ατομικά Γυναικών ΤΤ6-ΤΤ10</h4>
                    <h3><strong>1η Θέση</strong></h3>
                    <h5>Σύλλογος Π.Α.Σ.Κ.Α</h5>
                    <div class="d-flex justify-content-center w-100 flex-row text-center align-items-baseline">
                    </div>
                    <h5>Αθήνα Σ.Ε.Φ</h5>
                  </a>
                </div>
              </div>
                <hr />

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div style={{ width: "100%" }}><a href="#" class="title">
                  <h3><strong>ΔΙΑΣΥΛΛΟΓΙΚΟ ΠΡΩΤΑΘΛΗΜΑ Β' ΕΘΝΙΚΗΣ ΓΥΝΑΙΚΩΝ 2026 (Δυτ. Ελλάδα)</strong></h3>
                  <h3>Α.Ο ΓΑΛΗΝΗ Πατρών: 1η Θέση</h3>
                  <h5><strong>Ε.Φ.Ο.ΕΠ.Α</strong></h5>
                </a></div>
                <div  style={{width: "100%"}}>
                  <div style={styles.card}>
                    <Carousel interval={4200}>
                      <Carousel.Item>
                        <img src="/images/2026/B_Ethinki_1.JPG" alt="B Ethniki 2026 1" style={styles.imgTall} />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Πρωταθλήτριες Δ. Ελλάδας</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src="/images/2026/DSC_3388(1).JPG" alt="B Ethniki 2026 2" style={styles.imgTall} />
                        <Carousel.Caption style={styles.caption}>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src="/images/2026/galhnh_1.jpg" alt="B Ethniki 2026 2" style={styles.imgTall} />
                        <Carousel.Caption style={styles.caption}>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2026/kypello.jpg"
                          alt="B Ethniki 2026 Κύπελλο"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
              </div>

              <hr />

              <div class="d-flex justify-content-center text-center align-items-center mt-5 mb-5">
                <div class=""  style={{width: "100%", borderRadius: 20 }}>
                  <div style={styles.card}>
                    <Carousel interval={4000}>
                      <Carousel.Item>
                        <img
                          src="/images/2026/DSC_3400(1).JPG"
                          alt="Απονομή 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>3η Θέση • ΤΟΦΑΛΟΣ</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                      
                      <Carousel.Item>
                        <img
                          src="/images/2026/668288009_1592275872694599_567758465448190945_n(1).jpg"
                          alt="Απονομή 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Απονομή τίτλων</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          src="/images/2026/662933972_1592274896028030_2698075764499317838_n(1).jpg"
                          alt="Απολογισμός πρωταθλήματος 2026"
                          style={styles.imgTall}
                        />
                        <Carousel.Caption style={styles.caption}>
                          <h5 style={styles.capTitle}>Απολογισμός πρωταθλήματος</h5>
                        </Carousel.Caption>
                      </Carousel.Item>
                    </Carousel>
                  </div>
                </div>
                <div  style={{width: "100%"}} >
                  <a href="#" class="title">
                    <h3><strong>ΠΡΩΤΑΘΛΗΜΑ ΠΟΦΕΠΑ ΔΥΤ. ΕΛΛΑΔΑΣ 2026</strong></h3>
                    <h3>Σε εξέλιξη</h3>
                    <h5><strong>Π.Ο.Φ.ΕΠ.Α</strong></h5>
                  </a>
                </div>
              </div>
              <div class="text-center w-100 mb-4">
                <h2 style={{ marginTop: 50, marginBottom: 50, fontSize: '2.5rem' }}>
                  <a href="/Successes/2025" style={{ textDecoration: 'underline', color: '#0066cc' }}>
                    ΕΠΙΤΥΧΙΕΣ 2025 →
                  </a>
                </h2>
              </div>
                              <hr />

              <div class="row justify-content-center mt-5">
                <div class="row text-center mt-5 mb-3">
                  <h1><strong>ΠΑΝΕΛΛΗΝΙΑ ΠΡΩΤΑΘΛΗΜΑΤΑ</strong></h1>
                </div>
                <PanellhniaPrwtathlhmataCarousel />
              </div>
            </div>
          </div>

          <footer class="row  text-center text-lg-start mt-5">
            <div class="container p-4">
              <div class="row">
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0" />
                <div class="col-lg-6 col-md-12 mb-4 mb-md-0" />
              </div>
            </div>
            <div class="text-center p-3">© 2025 Copyright</div>
          </footer>
        </div>
    </>
  );
};

export default Home;
